<div class="min-h-screen bg-slate-50 p-4">
      <div class="max-w-6xl mx-auto space-y-4">

            <div class="bg-white rounded-lg shadow-sm border border-slate-200 p-4">
                  <div class="flex items-center justify-between">
                        <div>
                              <h2 class="text-lg font-semibold text-slate-800">Lookup Sources</h2>
                              <p class="text-xs text-slate-500">Manage dynamic lookup metadata and data sources</p>
                        </div>
                        <div class="flex items-center gap-3">
                              <div class="relative">
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                          <svg class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                          </svg>
                                    </div>
                                    <input [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" placeholder="Search..."
                                          class="w-44 pl-9 pr-3 py-1.5 text-sm border border-slate-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
                              </div>
                              <button (click)="openModal()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 text-sm rounded-md font-medium">
                                    + Create Source
                              </button>
                        </div>
                  </div>
            </div>

            <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
                  <div class="overflow-x-auto">
                        <table class="w-full text-sm">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 uppercase text-[11px] font-bold">
                                          <th class="px-3 py-3 text-left">Code / Name</th>
                                          <th class="px-3 py-3 text-left">Table Name</th>
                                          <th class="px-3 py-3 text-left">Value/Label</th>
                                          <th class="px-3 py-3 text-left">Search & Filters</th>
                                          <th class="px-3 py-3 text-left">Sorting</th>
                                          <th class="px-3 py-3 text-center">Status</th>
                                          <th class="px-3 py-3 text-right">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let item of sources" class="hover:bg-slate-50 transition-colors">
                                          <td class="px-3 py-3">
                                                <div class="font-medium text-slate-700">{{ item.code }}</div>
                                                <div class="text-[11px] text-slate-500">{{ item.name }}</div>
                                          </td>
                                          <td class="px-3 py-3 font-mono text-xs text-blue-600">{{ item.tableName }}
                                          </td>
                                          <td class="px-3 py-3 text-xs">
                                                <div class="text-slate-700 font-medium">V: {{ item.valueField }}</div>
                                                <div class="text-slate-500">L: {{ item.labelField }}</div>
                                          </td>
                                          <td class="px-3 py-3 text-[11px]">
                                                <div class="truncate max-w-[150px] text-slate-600" title="Search"> {{
                                                      item.searchFields }}</div>
                                                <div class="truncate max-w-[150px] text-slate-400" title="Filters"> {{
                                                      item.staticFilters }}</div>
                                          </td>
                                          <td class="px-3 py-3 text-xs uppercase text-slate-500">
                                                {{ item.sortField }} <span
                                                      class="text-[10px] bg-slate-100 px-1 rounded">{{ item.sortDir
                                                      }}</span>
                                          </td>
                                          <td class="px-3 py-3">
                                                <div class="flex items-center justify-center gap-1.5">
                                                      <span class="relative inline-flex rounded-full h-2 w-2"
                                                            [ngClass]="item.isActive ? 'bg-emerald-500' : 'bg-red-500'"></span>
                                                      <span class="text-xs font-medium"
                                                            [ngClass]="item.isActive ? 'text-slate-700' : 'text-slate-400'">
                                                            {{ item.isActive ? 'Active' : 'Inactive' }}
                                                      </span>
                                                </div>
                                          </td>
                                          <td class="px-3 py-3 text-right">
                                                <div class="flex items-center justify-end gap-3">
                                                      <button (click)="openModal(item)"
                                                            class="text-slate-400 hover:text-blue-600 transition-colors">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                                                  </path>
                                                            </svg>
                                                      </button>
                                                      <button (click)="delete(item.id)"
                                                            class="text-slate-400 hover:text-red-600 transition-colors">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                                  </path>
                                                            </svg>
                                                      </button>
                                                </div>
                                          </td>
                                    </tr>
                                    <tr *ngIf="sources.length === 0">
                                          <td colspan="7" class="py-12 text-center text-slate-400">No lookup sources
                                                found</td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>

                  <!-- <div
                        class="flex flex-wrap items-center justify-between gap-4 px-4 py-3 bg-white  border-slate-200 text-xs font-medium">
                        <div class="flex items-center gap-3 text-slate-600">
                              <span>Show</span>
                              <select [(ngModel)]="pageSize" (change)="filterData()"
                                    class="border border-slate-200 rounded-md px-2 py-1 bg-white outline-none focus:border-blue-500 shadow-sm">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                              </select>
                              <span>per page</span>
                        </div>
                        <div class="flex items-center gap-6 text-slate-600">
                              <span class="hidden sm:inline-block">
                                    Showing {{ pageIndex * pageSize + 1 }} to {{ ((pageIndex + 1) * pageSize) >
                                    filteredSources.length ? filteredSources.length : (pageIndex + 1) * pageSize }} of
                                    {{ filteredSources.length }}
                              </span>
                              <div class="flex items-center gap-2">
                                    <button (click)="pageIndex = pageIndex - 1" [disabled]="pageIndex === 0"
                                          class="w-8 h-8 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 shadow-sm text-slate-600">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M15 19l-7-7 7-7" stroke-width="2"></path>
                                          </svg>
                                    </button>
                                    <div
                                          class="w-8 h-8 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold shadow-inner">
                                          {{ pageIndex + 1 }}
                                    </div>
                                    <button (click)="pageIndex = pageIndex + 1"
                                          [disabled]="(pageIndex + 1) * pageSize >= filteredSources.length"
                                          class="w-8 h-8 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 shadow-sm text-slate-600">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M9 5l7 7-7 7" stroke-width="2"></path>
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div> -->
                  <div
                        class="flex flex-wrap items-center justify-between gap-4 px-4 py-3 bg-white border-t border-slate-200 text-xs font-medium">
                        <div class="flex items-center gap-3 text-slate-600">
                              <span>Show</span>
                              <select [(ngModel)]="pageSize" (change)="changePageSize()"
                                    class="border border-slate-200 rounded-md px-2 py-1 bg-white outline-none focus:border-blue-500 shadow-sm">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                              </select>
                              <span>per page</span>
                        </div>

                        <div class="flex items-center gap-6 text-slate-600">
                              <span class="hidden sm:inline-block">
                                    Showing {{ startRange }} to {{ endRange }} of {{ totalCount }}
                              </span>
                              <div class="flex items-center gap-2">
                                    <button (click)="changePage(pageIndex - 1)" [disabled]="pageIndex === 0"
                                          class="...">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M15 19l-7-7 7-7" stroke-width="2"></path>
                                          </svg>
                                    </button>

                                    <div
                                          class="w-8 h-8 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold">
                                          {{ pageIndex + 1 }}
                                    </div>

                                    <button (click)="changePage(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1"
                                          class="...">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path d="M9 5l7 7-7 7" stroke-width="2"></path>
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
</div>
<div *ngIf="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
            class="bg-white rounded-lg shadow-xl w-full max-w-lg overflow-hidden animate-in fade-in zoom-in duration-200 border border-slate-200">

            <div class="flex justify-between items-center px-4 py-2.5  bg-slate-50">
                  <h3 class="text-sm font-bold text-slate-800">
                        {{ currentSource.id ? 'Edit' : 'Create' }} Lookup Source
                  </h3>
                  <button (click)="isModalOpen = false" class="text-slate-400 hover:text-slate-600 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                  </button>
            </div>

            <div class="p-5 grid grid-cols-2 gap-x-4 gap-y-3">

                  <div class="space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Lookup Code</label>
                        <input [(ngModel)]="currentSource.code"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                              placeholder="e.g. items">
                  </div>

                  <div class="space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Display
                              Name</label>
                        <input [(ngModel)]="currentSource.name"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                              placeholder="e.g. Items List">
                  </div>

                  <div class="col-span-2 space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Database
                              Table</label>
                        <input [(ngModel)]="currentSource.tableName"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs font-mono text-blue-600 bg-slate-50 focus:bg-white outline-none transition-all"
                              placeholder="erp_items">
                  </div>

                  <div class="space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Value Field
                              (ID)</label>
                        <input [(ngModel)]="currentSource.valueField"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs outline-none focus:border-blue-500"
                              placeholder="id">
                  </div>

                  <div class="space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Label Field</label>
                        <input [(ngModel)]="currentSource.labelField"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs outline-none focus:border-blue-500"
                              placeholder="name">
                  </div>

                  <div class="col-span-2 space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Search Fields
                              (JSON)</label>
                        <input [(ngModel)]="currentSource.searchFields"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs font-mono bg-slate-50 focus:bg-white outline-none"
                              placeholder='["name", "code"]'>
                  </div>

                  <div class="col-span-2 space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Static Filters
                              (JSON)</label>
                        <input [(ngModel)]="currentSource.staticFilters"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs font-mono bg-slate-50 focus:bg-white outline-none"
                              placeholder='{"is_active": true}'>
                  </div>

                  <div class="space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Sort Field</label>
                        <input [(ngModel)]="currentSource.sortField"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs outline-none focus:border-blue-500">
                  </div>

                  <div class="space-y-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Direction</label>
                        <select [(ngModel)]="currentSource.sortDir"
                              class="w-full border border-slate-300 rounded px-2 py-1 text-xs outline-none focus:border-blue-500 bg-white">
                              <option value="asc">ASC</option>
                              <option value="desc">DESC</option>
                        </select>
                  </div>

                  <div class="col-span-2 flex items-center gap-2 py-1">
                        <input type="checkbox" [(ngModel)]="currentSource.isActive" id="isActive"
                              class="w-3.5 h-3.5 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer">
                        <label for="isActive" class="text-xs font-medium text-slate-700 cursor-pointer">Active
                              Source</label>
                  </div>
            </div>

            <div class="flex justify-end gap-2 px-4 py-3 bg-slate-50 ">
                  <button (click)="isModalOpen = false"
                        class="px-3 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-200 rounded transition-colors">
                        Cancel
                  </button>
                  <button (click)="save()"
                        class="px-4 py-1.5 text-xs font-bold bg-blue-600 hover:bg-blue-700 text-white rounded shadow-sm transition-all active:scale-95">
                        {{ currentSource.id ? 'UPDATE' : 'SAVE SOURCE' }}
                  </button>
            </div>
      </div>
</div>